import { State } from '../../reducers/rootReducer'
import Cart from '../../../entities/Cart'

const cartSelector = (state: State): Cart => state.cart

export default cartSelector
